import { ACCOUNT_VIEW_ACTIONS } from "constants/actions";

export function fetchAccountSummary(caseId) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_SUMMARY,
        payload: {
            caseId
        }
    };
}

export function fetchedAccountSummary(caseId, data) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCHED_ACCOUNT_SUMMARY,
        payload: {
            caseId,
            data
        }
    };
}

export function failedFetchAccountSummary(caseId, error) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_ACCOUNT_SUMMARY,
        payload: {
            caseId,
            error
        }
    };
}

export function fetchAccountStatement(caseId) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCH_ACCOUNT_STATEMENT,
        payload: {
            caseId
        }
    };
}

export function fetchedAccountStatement(caseId, data) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCHED_ACCOUNT_STATEMENT,
        payload: {
            caseId,
            data
        }
    };
}

export function failedFetchAccountStatement(caseId, error) {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_ACCOUNT_STATEMENT,
        payload: {
            caseId,
            error
        }
    };
}

export const fetchFacilityAccountOpenInvoices = (caseId) => {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCH_FACILITY_ACCOUNT_OPEN_INVOICES,
        payload: {
            caseId
        }
    };
};

export const fetchedFacilityAccountOpenInvoices = (caseId, data) => {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FETCHED_FACILITY_ACCOUNT_OPEN_INVOICES,
        payload: {
            caseId,
            data
        }
    };
};

export const failedFetchAccountOpenInvoices = (caseId, error) => {
    return {
        type: ACCOUNT_VIEW_ACTIONS.FAILED_FETCH_FACILITY_ACCOUNT_OPEN_INVOICES,
        payload: {
            error
        }
    };
};